import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from './utils/request.js';
import VideoPlayer from 'vue-video-player';
import 'vue-video-player/src/custom-theme.css';
import 'video.js/dist/video-js.css';
import '@/assets/css/main.css';
import '@/assets/css/element-ui-cover.scss';
import VueSuperSlide from 'vue-superslide'
Vue.use(ElementUI, {
    size: 'small'
});
Vue.use(VideoPlayer);
Vue.use(VueSuperSlide)
Vue.prototype.$axios = axios; //设置全局axios
new Vue({
  router,	
  render: h => h(App),
}).$mount('#app')
